import {
    Box,
    Button,
    CardActions,
    CardContent,
    Card,
    MenuItem,
    Select,
    Typography,
    Stack,
} from '@mui/material';
import React, { useState } from 'react';
import ViewReservationListComponent from '../../Reservations/ViewReservations/ViewReservationListComponent';
import { useGetAllReservationsQuery } from '../../../../app/Slices/SevenDayApiSlice';
import { NavigateNext } from '@mui/icons-material';
import ViewReservationsCalendarComponent from '../../Reservations/ViewReservations/ViewReservationsCalendarComponent';
import { useNavigate } from 'react-router-dom';

const Reservations = () => {
    const navigate = useNavigate();
    const { data: reservations } = useGetAllReservationsQuery({
        status: ['pending', 'approved'],
        sort: 'startDate',
    });

    const [view, setView] = useState<string>('list');

    return (
        <Stack sx={{ height: '100%' }}>
            <Box
                sx={{ display: 'flex', justifyContent: 'space-between', pb: 1 }}
            >
                <Typography variant='subHeading' sx={{ lineHeight: 2 }}>
                    Upcoming Reservations
                </Typography>
                <Select
                    value={view}
                    size='small'
                    onChange={(e) => setView(e.target.value)}
                    sx={{ fontSize: '14px' }}
                >
                    <MenuItem value='list'>List</MenuItem>
                    <MenuItem value='calendar'>Calendar</MenuItem>
                </Select>
            </Box>
            <Card
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <CardContent>
                    {view === 'calendar' ? (
                        <ViewReservationsCalendarComponent />
                    ) : (
                        <ViewReservationListComponent
                            reservations={reservations}
                            pageSize={10}
                        />
                    )}
                </CardContent>
                <CardActions sx={{ mt: 'auto' }}>
                    <Button
                        onClick={() => navigate('/reservations')}
                        endIcon={<NavigateNext />}
                        sx={{ ml: 'auto' }}
                    >
                        See all Reservations
                    </Button>
                </CardActions>
            </Card>
        </Stack>
    );
};

export default Reservations;
